import { resolveInstrument } from "../services/instrumentsApi";
import type { ResolveInstrumentRequest, ResolveInstrumentResponse } from "../types/instruments";
import {
  ohlcSourceMenuEntries,
  resolveNeedsOhlcSourceMenuRetry,
} from "./marketDataSourceChoice";

/**
 * POST /instruments/resolve — when BE returns an active lane but empty market_data_sources[],
 * retry once with explicit market_data_symbol so the full OHLC vendor menu can populate.
 */
export async function resolveInstrumentForOhlcMenu(
  request: ResolveInstrumentRequest
): Promise<ResolveInstrumentResponse> {
  const first = await resolveInstrument(request);
  if (!resolveNeedsOhlcSourceMenuRetry(first)) return first;

  const retrySymbol =
    first.market_data_symbol?.trim() ||
    request.market_data_symbol?.trim() ||
    request.resolved_symbol?.trim();
  if (!retrySymbol) return first;

  const retry = await resolveInstrument({
    ...request,
    resolved_symbol: retrySymbol,
    market_data_symbol: retrySymbol,
  });
  return ohlcSourceMenuEntries(retry).length > 0 ? retry : first;
}
